/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'media': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" d="M19 16.001H5a1 1 0 0 1-1-1v-14a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1Zm-13-2h12v-12H6v12Zm10 6H1a1 1 0 0 1-1-1v-15h2v14h14v2Zm-7-13a2 2 0 1 1 0-4 2 2 0 0 1 0 4Zm5 0 3 6H7l3-4 1.412 1.882L14 7.001Z" _fill="#adadad" fill-rule="evenodd"/>'
  }
})
